/**
 * Pricing Matrix functionality
 *
 * @description This file includes the required functionality for the pricing matrix in Pricing Page
 *
 * @return void
 * @access public
 *
 */

import {addEventListenerIfElExists, arrSum, findAncestor, formulaPriceOutput, numberWithCommas} from './helpers';

export const pricingMatrix = () => {
	let pricingMultiplierArray = []; // The array that will hold the pricinf multiplier
	const pricingFilters       = document.querySelectorAll( '.js-pricing-filter' );
	const activeFilterClass    = 'c-pricing-filter__link--active';
	const priceItems           = document.querySelectorAll( '.js-service-price' );

	/**
	 * Function to toggle between two classes using Vanilla JS
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	pricingFilters.forEach( ( filter, index ) => {

		// Add `click` event listener for each pricing filter item
		filter.addEventListener( 'click', event => {
			event.preventDefault(); // Prevent default behaviour
			// Set an empty array that will hold all price filter multipliers
			let tempPricingFormulaMultiplier = [];

			// Get current price filter multiplier
			const priceFilterMultiplier      = event.target.getAttribute( 'data-multiplier' );

			// Find all siblings to the current clicked filter element and remove the active class
			findAncestor( event.target, '.c-pricing-filters__item' ).querySelectorAll( '.c-pricing-filter__link' ).forEach( ( item, index ) => {
				item.classList.remove( activeFilterClass );
			} );

			// Then add the active class on the clicked element
			event.target.classList.add( activeFilterClass );

			// Go through all price filter items and find those that
			// have an active class and push their multiplier value into an array
			Array.from( pricingFilters ).map( item => {
				if ( item.classList.contains( activeFilterClass ) === true ) {
					// Turn the variables into an Float and pass the
					// multiplier data attribute through the dataset attribute
					// but before pushing the data attribute divide it by 1.25 if value `equals` 1
					tempPricingFormulaMultiplier.push( parseFloat( item.dataset.multiplier == 1 ? item.dataset.multiplier : item.dataset.multiplier / 1.25 ) );
				}
			} );

			const pricingFormulaMultiplier      = arrSum( tempPricingFormulaMultiplier );
			const pricingFormulaMultiplierFinal = arrSum( tempPricingFormulaMultiplier ) / 2;

			// Run through each price item to change the price value based on current state
			priceItems.forEach( ( item ) => {
				const initialPrice    = item.getAttribute( 'data-initial-price' );
				const priceMultiplier = item.getAttribute( 'data-multiplier' );
				const newPrice        = initialPrice * pricingFormulaMultiplierFinal;

				// Check if the Pricing Formula Multiplier `equals` 3 which means that all filters
				// are set to 1 and show the initial price, otherwise pass the following formula functions to the price
				if ( pricingFormulaMultiplier <= 3 ) {
					item.innerHTML = parseInt( initialPrice );
				} else {
					// item.innerHTML = parseInt(initialPrice);
					item.innerHTML = numberWithCommas( formulaPriceOutput( newPrice, priceMultiplier ) );
				}

			} );
		} );
	} );

}
